module.exports = __webpack_public_path__ + "static/media/LandingScreen_elBlurredwallpaperpreview_205816.c4809fd5.jpg";